import { render, staticRenderFns } from "./ViolationEmployee.vue?vue&type=template&id=3964af9e&"
import script from "./ViolationEmployee.vue?vue&type=script&lang=js&"
export * from "./ViolationEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports